'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);

var _beautifyNumber = require('../../helpers/beautifyNumber');var _beautifyNumber2 = _interopRequireDefault(_beautifyNumber);

var _ProjectInfoWindow = require('./ProjectInfoWindow.scss');var styles = _interopRequireWildcard(_ProjectInfoWindow);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // Helpers

var ProjectInfoWindow = function ProjectInfoWindow(props) {
  var formatPrice = function formatPrice() {var
    price = props.price,exactPrice = props.exactPrice,translate = props.translate;
    var nis = String.fromCharCode(8362);
    var ltrSymbol = String.fromCharCode(8206);

    var formattedPrice = exactPrice ? '' +
    ltrSymbol + nis + ' ' + (0, _beautifyNumber2.default)(exactPrice) :
    translate('from') + ' ' + nis + (0, _beautifyNumber2.default)(price);

    return formattedPrice;
  };

  return (
    _react2.default.createElement('div', { className: styles.projectInfoWindow, onClick: props.openDetails },
      _react2.default.createElement('div', { className: styles.imageSection },
        _react2.default.createElement('div', { className: styles.image, style: { backgroundImage: 'url(' + props.image + ')' } }),
        _react2.default.createElement('div', { className: styles.price }, formatPrice())),

      _react2.default.createElement('div', { className: styles.descriptionSection },
        _react2.default.createElement('div', { className: styles.name }, props.name),
        _react2.default.createElement('div', null,
          _react2.default.createElement('div', null, props.address.street_name, '\xA0', props.address.house_number, ','),
          _react2.default.createElement('div', null, props.address.city_name)),

        _react2.default.createElement('div', { className: styles.status }, _react2.default.createElement('b', null, props.translate('status'), ':\xA0'), props.status))));



}; // Styles

ProjectInfoWindow.propTypes = {
  image: _propTypes2.default.string,
  price: _propTypes2.default.number,
  exactPrice: _propTypes2.default.number,
  name: _propTypes2.default.string,
  address: _propTypes2.default.object,
  status: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  openDetails: _propTypes2.default.func };exports.default =


ProjectInfoWindow;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectInfoWindow/ProjectInfoWindow.js
// module id = 1216
// module chunks = 0